import type { RaidHudSnapshot } from "../../../features/raid";

/** Prep-in-progress > commit echo > idle. Cancelled gestures never set echoKey. */
export type RaidCmdChip =
  | { mode: "idle" }
  | {
      mode: "prep";
      kind: Exclude<RaidHudSnapshot["prepKind"], "idle">;
      unitId: number;
    }
  | { mode: "echo"; messageKey: string };

export function resolveRaidCmdChip(
  snap: Pick<RaidHudSnapshot, "prepKind" | "prepUnitId" | "echoKey">,
): RaidCmdChip {
  if (snap.prepKind !== "idle") {
    return { mode: "prep", kind: snap.prepKind, unitId: snap.prepUnitId };
  }
  if (snap.echoKey) return { mode: "echo", messageKey: snap.echoKey };
  return { mode: "idle" };
}
